export function getGeometryCoordinates(_geometry: unknown) {
	const geometry = _geometry as { coordinates?: [number, number] } | string;
	if (typeof geometry === "string") {
		return wkbHexToCoordinates(geometry);
	} else {
		if (!geometry?.coordinates) return { latitude: null, longitude: null };
		return { latitude: geometry.coordinates[1]!, longitude: geometry.coordinates[0]! };
	}
}

function wkbHexToCoordinates(hex: string) {
	const uintArray = hex.match(/.{2}/g);
	if (!uintArray) return { latitude: null, longitude: null };
	const bytes = new Uint8Array(uintArray.map((b) => Number.parseInt(b, 16)));
	const view = new DataView(bytes.buffer);
	const littleEndian = bytes[0] === 1;
	const longitude = view.getFloat64(5, littleEndian);
	const latitude = view.getFloat64(13, littleEndian);
	return { latitude, longitude };
}
